export * from './key-value-pair.interface';
export * from './partner.interface';
export * from './bank.interface';